/**
 * Viraasat Audio Controller
 *
 * Handles background audio playback with mute/unmute toggle.
 * Respects browser autoplay policies.
 */

(function() {
  'use strict';

  class ViraasatAudio {
    constructor() {
      this.container = document.querySelector('[data-audio-player]');
      if (!this.container) return;

      this.audio = this.container.querySelector('[data-audio-element]');
      this.toggle = this.container.querySelector('[data-audio-toggle]');
      this.iconMuted = this.container.querySelector('[data-icon-muted]');
      this.iconPlaying = this.container.querySelector('[data-icon-playing]');

      if (!this.audio || !this.toggle) return;

      this.isMuted = true;

      // Get volume from settings or default to 30%
      const settings = window.Viraasat?.settings || {};
      this.volume = settings.audioVolume || 0.3;
      this.audio.volume = this.volume;

      this.init();
    }

    init() {
      this.bindEvents();
      this.updateUI();
    }

    bindEvents() {
      this.toggle.addEventListener('click', () => this.toggleMute());

      // Handle audio errors gracefully
      this.audio.addEventListener('error', () => {
        console.warn('Viraasat Audio: Failed to load audio file');
      });
    }

    toggleMute() {
      if (this.isMuted) {
        this.unmute();
      } else {
        this.mute();
      }
      this.updateUI();
    }

    unmute() {
      this.audio.muted = false;

      // Ensure playback position is valid
      if (isNaN(this.audio.currentTime)) {
        this.audio.currentTime = 0;
      }

      // Attempt to play with fallback
      const playPromise = this.audio.play();

      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            this.isMuted = false;
            this.updateUI();
          })
          .catch(() => {
            // Fallback: reload and try again
            this.audio.load();
            this.audio.play().catch(() => {
              console.warn('Viraasat Audio: Browser blocked autoplay');
            });
            this.isMuted = false;
            this.updateUI();
          });
      }

      this.isMuted = false;
    }

    mute() {
      this.audio.pause();
      this.isMuted = true;
    }

    updateUI() {
      if (this.iconMuted && this.iconPlaying) {
        if (this.isMuted) {
          this.iconMuted.style.display = 'block';
          this.iconPlaying.style.display = 'none';
          this.toggle.setAttribute('aria-label', 'Unmute');
        } else {
          this.iconMuted.style.display = 'none';
          this.iconPlaying.style.display = 'block';
          this.toggle.setAttribute('aria-label', 'Mute');
        }
      }
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => new ViraasatAudio());
  } else {
    new ViraasatAudio();
  }
})();
